<div>
  <div class="content-card table-wrapper custom-table">
    <!-- Employment History's Table -->
    <mat-table
      #table
      matSort
      class="desktop"
      matSortActive="startDate"
      matSortDirection="desc"
      matSortDisableClear
      [dataSource]="dataSource.sickLeaves$ | async"
    >
      <!-- EmployerObject Column -->
      <ng-container matColumnDef="employerObject">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'EmployerObject' | translate }} <app-table-header-sort></app-table-header-sort
        ></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.EmployerObject }}</mat-cell>
      </ng-container>
      <!-- Absence Reason Column -->
      <ng-container matColumnDef="reason">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'worker-illness.sickLeaveType' | translate }} <app-table-header-sort></app-table-header-sort
        ></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.Type }}</mat-cell>
      </ng-container>
      <!-- Period Date Column -->
      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'worker-illness.period' | translate }} <app-table-header-sort></app-table-header-sort
        ></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.StartDate | date : 'yyyy-MM-dd' }} - {{ element.EndDate | date : 'yyyy-MM-dd' }}</mat-cell>
      </ng-container>
      <!-- Calendar Days Column -->
      <ng-container matColumnDef="calendarTimeTicks">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'worker-illness.calendar' | translate }} <app-table-header-sort></app-table-header-sort
        ></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.CalendarDays }}</mat-cell>
      </ng-container>
      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Status' | translate }} <app-table-header-sort></app-table-header-sort
        ></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.Status }}</mat-cell>
      </ng-container>
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef> {{ 'Actions' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button
            [visibleWithPermissionsOnWorkerProfile]="['GetMyWorkerSickLeavesDetails', 'GetAllWorkerSickLeavesDetails']"
            [authServerUserId]="profile?.AuthServerUserId"
            mat-icon-button
            (click)="openDetailsModal(element)"
          >
            <mat-icon>visibility</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
    <mat-table
      #table
      matSort
      class="mobile"
      matSortActive="startDate"
      matSortDirection="desc"
      matSortDisableClear
      [dataSource]="dataSource.sickLeaves$ | async"
    >
      <!-- Absence Type Column -->
      <ng-container matColumnDef="absenceType">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'AbsenceType' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.AbsenceType }}</mat-cell>
      </ng-container>
      <!-- Absence Type Column -->
      <ng-container matColumnDef="reason">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'worker-illness.reason' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.Reason }}</mat-cell>
      </ng-container>
      <!-- Calendar Days Column -->
      <ng-container matColumnDef="calendarTimeTicks">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'worker-illness.calendarDays' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.CalendarTimeTicks | ticksToString : 'dd hh mm' }}</mat-cell>
      </ng-container>
      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Status' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.Status }}</mat-cell>
      </ng-container>
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef> {{ 'Actions' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button
            [visibleWithPermissionsOnWorkerProfile]="['GetMyWorkerSickLeavesDetails', 'GetAllWorkerSickLeavesDetails']"
            [authServerUserId]="profile?.AuthServerUserId"
            mat-icon-button
            (click)="openDetailsModal(element)"
          >
            <mat-icon>visibility</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumnsMobile"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumnsMobile"></mat-row>
    </mat-table>
  </div>

  <mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"> </mat-paginator>
</div>
